export const STEP_CHAT_VERBS = [
  'Noodling',
  'Pondering',
  'Ruminating',
  'Thinking',
  'Musing',
  'Contemplating',
  'Mulling',
  'Brainstorming',
  'Cogitating',
  'Deliberating',
  'Reflecting',
  'Considering',
  'Reasoning',
  'Working',
  'Hustling',
  'Processing',
  'Analyzing',
  'Synthesizing',
  'Connecting',
  'Vibing',
  'Weaving',
  'Crafting',
  'Composing',
  'Formulating',
  'Brewing',
  'Churning',
  'Percolating',
  'Simmering',
  'Cooking',
  'Conjuring',
  'Musing',
  'Articulating',
];

export const EXTRACT_OBJECT_VERBS = [
  'Extracting',
  'Parsing',
  'Distilling',
  'Sifting',
  'Mining',
  'Harvesting',
  'Gleaning',
  'Gathering',
  'Collecting',
  'Plucking',
  'Filtering',
  'Refining',
  'Crystallizing',
  'Isolating',
  'Decoding',
  'Unpacking',
  'Unwrapping',
  'Unearthing',
  'Excavating',
  'Discovering',
  'Identifying',
  'Pinpointing',
  'Locating',
  'Spotting',
  'Detecting',
  'Capturing',
  'Securing',
  'Nabbing',
  'Snaring',
  'Fetching',
];

export const PENDING_VERBS = [
  'Preparing',
  'Focusing',
  'Launching',
  'Initializing',
  'Warming up',
  'Getting ready',
  'Gearing up',
  'Spinning up',
  'Booting',
  'Loading',
  'Queuing',
  'Staging',
  'Prepping',
  'Setting up',
  'Standing by',
];

export const RETRY_VERBS = [
  'Recovering',
  'Trying again',
  'Regrouping',
  'Bouncing back',
  'Retrying',
  'Dusting off',
  'Getting back up',
  'Rallying',
  'Persevering',
  'Persisting',
  'Resuming',
  'Restarting',
  'Reattempting',
  'Taking another shot',
  'Giving it another go',
];
